import { Button, Modal } from 'react-bootstrap';

export default function DashboardMarkAsFavoriteModal({
  showMarkAsFavoriteModal,
  setShowMarkAsFavoriteModal,
  onConfirm,
  isFavorite,
}: {
  showMarkAsFavoriteModal: boolean;
  setShowMarkAsFavoriteModal: (b: boolean) => void;
  onConfirm: () => void;
  isFavorite: boolean;
}) {
  return (
    <Modal
      show={showMarkAsFavoriteModal}
      onHide={() => {
        setShowMarkAsFavoriteModal(false);
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="p-3">
        <h4 className="text-center">{isFavorite ? 'Unmark as favorite' : 'Mark as favorite'}</h4>
        <div className="text-center my-3">
          <p>
            {isFavorite
              ? 'Are you sure you want to unmark this dashboard as favorite?'
              : 'Are you sure you want to mark this dashboard as favorite?'}
          </p>
        </div>
        <Modal.Footer>
          <Button
            style={{ height: '40px', fontFamily: 'Inter' }}
            className="btn btn-warning"
            onClick={() => {
              setShowMarkAsFavoriteModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            style={{ height: '40px', fontFamily: 'Inter' }}
            className="btn btn-success"
            onClick={() => {
              onConfirm();
              setShowMarkAsFavoriteModal(false);
            }}
          >
            {isFavorite ? 'Unmark as favorite' : 'Mark as favorite'}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}
